// Media series consistency constraint
// Encourage the same person to be assigned across recurring events (series) for the same role.
// We introduce binary indicators ys_{U}_{S}_{R} that turn on if user U is used at least once
// for series S in role R. For each event E in that series/role and eligible user U, add:
//   x_{U,E,R} - ys_{U,S,R} <= 0
// This links the indicator to any assignment in the series; the objective can then penalize
// distinct users (sum of ys over U) to push for consistency.
//
// Requires indexes: seriesRoleEvents, decisionVariables, seriesDistinctDecisionVariables
export function buildMediaSeriesConsistencyConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const seriesRoleEvents = idx?.seriesRoleEvents || {};
  const declaredX = new Set(Object.keys(idx?.decisionVariables || {}));
  const declaredYs = new Set(Object.keys(idx?.seriesDistinctDecisionVariables || {}));
  const users = Object.keys(idx?.users || {});

  const constraints = [];
  for (const [sKey, perRole] of Object.entries(seriesRoleEvents)) {
    for (const rKey of Object.keys(perRole || {})) {
      const eKeys = Array.isArray(perRole[rKey]) ? perRole[rKey] : [];
      if (!eKeys.length) continue;
      for (const uKey of users) {
        const yName = `ys_${uKey}_${sKey}_${rKey}`;
        if (!declaredYs.has(yName)) continue;
        for (const eKey of eKeys) {
          const xName = `x_${uKey}_${eKey}_${rKey}`;
          if (!declaredX.has(xName)) continue;
          // x_{u,e,r} - ys_{u,s,r} <= 0
          constraints.push({ linear: { vars: [xName, yName], coeffs: [1, -1] }, domain: [-100000, 0] });
        }
      }
    }
  }
  return constraints;
}

